export default __webpack_public_path__ + "static/media/kids_banner.e9610d3d.jpg";